import { render, staticRenderFns } from "./ClientSettingMatchEmails.vue?vue&type=template&id=77ff4a58&"
import script from "./ClientSettingMatchEmails.vue?vue&type=script&lang=js&"
export * from "./ClientSettingMatchEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VFlex,VLayout,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ff4a58')) {
      api.createRecord('77ff4a58', component.options)
    } else {
      api.reload('77ff4a58', component.options)
    }
    module.hot.accept("./ClientSettingMatchEmails.vue?vue&type=template&id=77ff4a58&", function () {
      api.rerender('77ff4a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Game/ClientSettingMatchEmails.vue"
export default component.exports